import React, { Component } from 'react'

class Order extends Component{
  constructor() {
    super();
    this.state = {
      order: {},
      order_details: []
    }

    this.getOrder = this.getOrder.bind(this)
  }

  getOrder() {
    const order_id = this.props.match.params.id
    const token = localStorage.getItem("admin-token")
    const headers = { "Content-Type": "application/json",};
    headers["Authorization"] = `Token ${token}`;
    fetch(`/api/admin/order/${order_id}`, {headers, method: "GET"})
      .then(res => {
        if (res.status === 200) {
          res.json().then(json_res => {
            this.setState({
              order: json_res.order,
              order_details: json_res.order_details
            })
          })
        }  else {
          console.log("Server Error!");
        }
      })
  }

  componentDidMount() {
    this.getOrder()
  }

  render() {
    return(
      <div className="Order">
        <h1>Order - {this.props.match.params.id}</h1>
        <div className="Products-body">
          <h2>Info</h2>
          <div className="Customer-form-row">
            <div className="Customer-form-section">
              <label className="Account-label">Order id</label>
              <p>{this.state.order.id}</p>
            </div>
            <div className="Customer-form-section">
              <label className="Account-label">Klarna id</label>
              <p>{this.state.order.klarna_id}</p>
            </div>
          </div>
          <div className="Customer-form-row">
            <div className="Customer-form-section">
              <label className="Account-label">Total (ink moms)</label>
              <p>{this.state.order.total}kr</p>
            </div>
            <div className="Customer-form-section">
              <label className="Account-label">Ex moms</label>
              <p>{this.state.order.total * 0.80}kr</p>
            </div>
          </div>
          <div className="Customer-form-row">
            <div className="Customer-form-section">
              <label className="Account-label">Kund Namn</label>
              <p>{this.state.order.user_first_name} {this.state.order.user_last_name}</p>
            </div>
            <div className="Customer-form-section">
              <label className="Account-label">Kund konto email</label>
              <p>{this.state.order.user_email}</p>
            </div>
          </div>
          <h2>Order detaljer</h2>
            <table>
              <thead>
                <tr>
                  <th>Artikel nummer</th>
                  <th>Produkt</th>
                  <th>Moms</th>
                  <th>Pris (ink moms)</th>
                  <th>Kvantitet</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.order_details.map(item => {
                    return(
                      <tr key={item.product__article_number}>
                        <td>{item.product__article_number}</td>
                        <td>{item.product__title}</td>
                        <td>{item.product__vat}kr</td>
                        <td>{item.product__price}kr</td>
                        <td>{item.quantity}</td>
                        <td>{item.total_price}kr</td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
        </div>
      </div>
    )
  }
}

export default Order



// WEBPACK FOOTER //
// ./src/containers/admin/containers/Order.jsx